<template>
  <div class="index">
    <!-- 上面的背景图片 -->
    <div class="Imgbg">
      <!-- 背景图上的内容 -->
      <div class="w1200 headbox">
        <div class="kuang">
          <img :src="showDetailInfo.headImg||showDetailInfo.companyHeadImg" />
        </div>
        <div class="name">{{detailData.u_nickName||detailData.name}}</div>
        <div class="info">
          <span v-for="(x,i) in showDetailInfo.topInfo" :key="i" v-if="detailData[x.key]">
            {{(detailData[x.key]!==''?(x.prefix||'')+detailData[x.key]+(x.suffix||''):'')}}
          </span>
          <span>
            <i class="iconfont">&#xe618;</i>
            {{detailData.viewTime+'次'}}
          </span>
        </div>
      </div>
    </div>
    <!-- 中间导航部分 -->
    <div class="w1200 nav">
      <detailNav :disabled="!companyData.id" v-if="navAc!=='qiuzhi'&&navAc!=='jiaoyou'"></detailNav>
    </div>
    <!-- 展示数据部分 -->
    <div  class="w1200 showDetailbox flex">
      <div class="left" v-if="navAc!=='qiuzhi'" >
        <!-- 服务名 -->
        <div class="typeName">
          <span class="shu"></span>
          <b>{{this.showDetailInfo.typeName}}</b>
        </div>
        <!-- 头像信息 -->
        <div class="headInfo flex">
          <div><img :src="showDetailInfo.headImg" /></div>
          <div class="info">
            <span class="name">{{showDetailInfo.name}}</span>
            <!-- 动态渲染基本信息数据 -->
            <span v-for="(x,i) in showDetailInfo.headDetailInfo" :key="i">{{x.label}}{{x.value}}</span>
          </div>
        </div>
        <!-- 介绍信息 -->
        <div class="descriptionInfo" v-for="(x,i) in showDetailInfo.midDetailInfo" :key="i">
          <div class="descriptionName">{{x.label}}</div>
          <div class="descriptionCont">{{x.value}}</div>
        </div>
        <!-- 完整信息 -->
        <div class="detailInfo">
          <div class="title">
            <span class="shu"></span>
            <b>基本资料</b>
          </div>
          <div class="cont">
            <!-- <span class="list"  v-for="item in showDetailInfo.footDetailInfo"> -->
            <span class="list" :class="{'isShow':isShowPictures}" v-for="(x,i) in showDetailInfo.footDetailInfo" :key="i">
              <div v-if="x.value!==detailData.showUrls">{{x.label}}{{x.value}}</div>
              <div class="pictures" v-else>
                <p>{{x.label}}</p>
                <span class="imgbox" v-for="(x2,i2) in x.value" :key="i2" @click="previewImg(i2)">
                  <div class="demo-image__preview">
                    <el-image :src="x2|toimg" :preview-src-list="imgArr" :fit="'cover'"></el-image>
                  </div>
                </span>
              </div>
            </span>
          </div>
        </div>
        <!-- 介绍信息 -->
        <div class="infobox" v-if="companyData.id">
          <div class="descriptionInfo">
            <div class="descriptionName">
              <span class="shu"></span>
              <b>联系名片</b>
            </div>
            <div class="descriptionCont">
              <div v-for="(x,i) in cardInfo2" :key="i">{{x.label+'：'+companyData[x.value]}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 展示详情是求职时，显示 -->
      <div id="leftInfo" class="left" v-if="navAc==='qiuzhi'">
        <!-- 完整信息 -->
        <div class="detailInfo">
          <div class="title">
            <span class="shu"></span>
            <b>基本资料</b>
          </div>
          <div class="cont">
            <!-- <span class="list"  v-for="item in showDetailInfo.footDetailInfo"> -->
            <span class="list" :class="{isShow:isShowPictures}" v-for="(x,i) in showDetailInfo.footDetailInfo" :key="i">
              <div v-if="x.value!=detailData.showUrls">{{x.label}}{{x.value}}</div>
            </span>
          </div>
        </div>
        <!-- 介绍信息 -->
        <div class="infobox">
          <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">职业规划</el-menu-item>
            <el-menu-item index="2">视频简介</el-menu-item>
          </el-menu>
          <div class="videobox" v-show="showvideo">
            <div class="videodiv">
              <video v-if="detailData.u_videoUrl" :src="detailData.u_videoUrl" class="avatar video-avatar videoBox" controls="controls">您的浏览器不支持视频播放</video>
              <p style="padding:40px;" v-else>用户还未上传视频</p>
            </div>
          </div>
          <div v-show="!showvideo">
            <div class="descriptionInfo" v-for="(x,i) in showDetailInfo.midDetailInfo" :key="i">
              <div class="descriptionName">
                <span class="shu"></span>
                <b>{{x.label}}</b>
              </div>
              <div class="descriptionCont">{{x.value}}</div>
            </div>
            <div class="descriptionInfo">
              <div class="descriptionName">
                <span class="shu"></span>
                <b>联系名片</b>
              </div>
              <div class="descriptionCont">
                <div v-for="(x,i) in cardInfo" :key="i">{{x.label+'：'+(userInfo&&(userInfo.o_vipType>0||userInfo.admin)?detailData[x.value]:'****')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- 展示详情是求职时 -->
        <div class="btnbox flex" v-if="navAc==='qiuzhi'">
          <el-button v-for="(x,i) in btnArr" :key="i" @click="clickbtn(x.key)">{{x.label}}</el-button>
        </div>
        <contactCard :interactionShow="true" :complaintShow="true"></contactCard>
      </div>
    </div>
    <!-- 面试邀请弹框 -->
    <el-dialog class="inviteInterDialog" title="面试邀请" :visible.sync="inviteInterviewVisible" width="30%">
      <el-form :model="inviteInterviewForm" ref="inviteInterviewForm" :rules="inviteInterviewRules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="岗位名称" prop='jobName'>
          <el-select v-model="inviteInterviewForm.jobName" clearable placeholder="请选择">
            <el-option v-for="(x,i) in inviteInterviewJob" :key="i" :label="x" :value="x">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="面试方式" prop='type'>
          <el-select v-model="inviteInterviewForm.type" clearable placeholder="请选择">
            <el-option v-for="(x,i) in inviteInterviewType" :key="i" :label="x" :value="x">
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inviteInterviewVisible=false">取 消</el-button>
        <el-button type="primary" @click="submitInviteInterview()" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fuwuList } from '@/publicData/fuwuList'
import detailNav from '@/views/showpage/components/detailNav' // 详情导航组件
import contactCard from '@/views/showpage/components/contactcard' // 联系名片组件
export default {
  components: { detailNav ,contactCard},
  data() {
    return {
      navAc: 'jiaoyu',
      id: '',
      
      fuwulist: fuwuList,
      detailData: {},
      companyData: {
        id: ''
      },
      isShowPictures: false,
      showPicturesArr: [], // 接收详情数据中的套图数组，变成链接的图片数组，未经处理，和拿过来的数据顺序相同
      imgArr: [], // 预览模式下的图片数组，顺序由点击的图片而定

      showvideo: false, // 当服务名为求职时，点击视频简介，更换内容

      inviteInterviewForm: {}, // 面试邀请表单对象
      inviteInterviewRules: {
        jobName: [{ required: true, message: '岗位名称不能为空', trigger: 'change' }],
        type: [{ required: true, message: '面试方式不能为空', trigger: 'change' }]
      }, // 表单验证
      inviteInterviewType: ['线下面试','微信','QQ','云视频'], // 线上面试采用的app
      inviteInterviewVisible: false, // 面试邀请弹框是否显示
      inviteInterviewJob: [], // 面试邀请的岗位下拉框选项

      
      btnArr: [
        {label:'下载简历',key:'downloadResume'},
        {label:'打印简历',key:'printResume'},
        {label:'收藏简历',key:'collectionResume'},
        {label:'邀请面试',key:'inviteInterview'},
        {label:'视频面试',key:'videoInterview'},
      ], // 当服务详情为求职时，右边多一个放按钮的盒子
      showDetailInfo: {}, // 当路由是detail时的信息配置

      cardInfo: [
        {label:'固定电话',value:'u_fixPhone'},
        {label:'手机号码',value:'u_phone'},
        {label:'电子邮箱',value:'u_email'},
        {label:'QQ 号码',value:'u_QQ'},
        {label:'微信账号',value:'u_weixin'},
        {label:'微博账号',value:'u_weibo'},
      ],
      cardInfo2: [
        {label:'联系电话',value:'o_phone'},
        {label:'QQ 号码',value:'o_QQ'},
        {label:'微信账号',value:'o_weixin'},
      ],
    }
  },
  computed: {
    routePage() {
      return this.$route.name
    }
  },
  watch: {
    //点击面试邀请
    inviteInterviewVisible(val) {
      if (!val) {
        this.inviteInterviewForm = {}
        this.inviteInterviewJob = []
      }
    }
  },
  methods: {
    //服务类型为求职时，点击 职业规划 和 视频简介  相互切换
    handleSelect(key) {
      console.log(key)
      if (key === '1') {
        this.showvideo = false
      } else {
        this.showvideo = true
      }
    },
    //服务类型为求职时 点击右边中的按钮，调用下面的方法
    clickbtn(key) {
      this[key]()
    },
    //下载简历
    downloadResume() {
      this.$api.downloadResume({userId:this.detailData.id}).then(res => {
        if (res.data.status === 0) {
          console.log(JSON.parse(res.data.data))
          window.open(JSON.parse(res.data.data).fileUrl)
        } else {
          this._status(res.data)
        }
      })
    },
    //打印简历
    printResume() {
      window.print()
    },
    //收藏简历
    collectionResume() {
      console.log('收藏简历')
    },
    //邀请面试
    inviteInterview() {
      if (this.userInfo.organization) {
        this.inviteInterviewForm.organizationName = this.userInfo.o_name
        
        let rD = { organizationName: this.userInfo.o_name }
        this.$api.util_search('zhaopin', rD).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            _R.forEach(x => {
              this.inviteInterviewJob.push(x.jobName)
            })
            this.inviteInterviewVisible = true
          } else { this._status(res.data) }
        })
      } else { this.$message.warning('此操作仅限企业账号') }
    },
    //提交邀请面试表单
    submitInviteInterview() {
      this.inviteInterviewForm.userId = this.detailData.id
      this.inviteInterviewForm.u_userName = this.detailData.u_nickName
      this.inviteInterviewForm.u_education = this.detailData.u_education
      this.inviteInterviewForm.o_id = this.userInfo.id
      this.$refs['inviteInterviewForm'].validate((valid) => {
        if (valid) {
          console.log(this.inviteInterviewForm)
          this.$api.util_create('mianshi', this.inviteInterviewForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('发送邀请成功!')
              this.inviteInterviewVisible = false
            } else if (res.data.status === 19) {
              console.log(this.inviteInterviewForm)
              console.log(res)
              this.$message.info('请勿对同一位求职者重复发送邀请!')
            } else {
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //视频面试
    videoInterview() {
      console.log('视频面试')
    },

    rightFormSubmit(content, title) {
      if (content==='') {
        this.$message.error('请填写内容后再提交！')
      } else {
        if (title === '互动交流') {
          console.log('内容', content)
        } else {//投诉
          console.log('内容', content, '律师',this.layerData, '公司',this.companyData, '详情',this.detailData)
          
          let userId = this.userInfo.id
          let areaId = this.areaIds_x[this.areaIds_x.length - 1]
          let route = this.$route.name
          let targetId = this.companyId
          let subName = ''

          if (['detail','detailList'].includes(route) && !this.companyData) {
            this.$message.warning('企业信息不完善！')
            return
          } else {
            switch (route) {
              case 'detail':
                targetId = this.companyData.id || this.detailData.id
                subName = this.detailData.name
              break
              case 'detailList':
                targetId = this.companyData.id
                subName = this.companyData.name
              break
              case 'layerDetail':
                targetId = this.layerData.ownerId
                subName = this.layerData.name
              break
            }

            let rD = {
              areaId,
              targetId,
              subName,
              userId,
              content,
            }
            console.log(rD)
            this.$confirm('确定要投诉此信息?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.util_create('tousu', rD).then(res => {
                if (res.data.status === 0) {
                  this.$message.success('投诉成功！')
                } else { this._status(res.data) }
              })
            }).catch(() => {})
          }
        }
      }
    },

    //照片墙查看,预览模式下，图片数组的顺序需要经过处理
    previewImg(clickIndex) {
      this.imgArr = new Array(this.showPicturesArr.length)
      this.showPicturesArr.forEach((item,index) => {
        if ( index >= clickIndex ) {//当遍历索引大于点击对应的索引时，将这个值赋给 索引为index-clickIndex的元素
          this.imgArr[index-clickIndex] = this.puUrl_x + '/' + item
        } else {//当遍历索引小于点击对应的索引时，将这个值赋给 索引为index+（length-clickIndex）的元素
          this.imgArr[index+(this.showPicturesArr.length-clickIndex)] = this.puUrl_x + '/' + item
        }
      })
    },
  
    // 根据服务类型的不同，展示的数据不同
    dataHandler() {
      // console.log(this.detailData)
      let typeName = '' // 服务名称，渲染在详情顶部
      typeName = this.fuwulist.find(x => x.value === this.navAc).name

      let companyHeadImg = require('@/assets/logo.png'),
          headImg = require('@/assets/logo.png')

      let {
        u_nickName,
        name,
        u_logo,
        imgUrl
      } = this.detailData

      if (['qiuzhi', 'jiaoyou'].includes(this.navAc)) {
        name = u_nickName
        u_logo ? headImg = this.puUrl_x + '/' + u_logo : ''
      } else {
        if (imgUrl) {
          headImg = this.puUrl_x + '/' + imgUrl
        } else if (['lvshi', 'jiaoyou'].includes(this.navAc)) {
          headImg = require('@/assets/lvshi.png')
        }
        if (this.companyData.o_homeUrl) {
          companyHeadImg = this.puUrl_x + '/' + this.companyData.o_homeUrl
        }
      }

      let topInfo, // 头像下面的动态渲染的数据
          headDetailInfo, // 放头部的渲染的数据
          midDetailInfo, // 放中间的介绍部分的数据
          footDetailInfo, // 底部的基本信息数据
          zhiyeguihua = '职业规划'

      switch (this.navAc) {
        case 'qiuzhi':
          topInfo = [
            {key:'u_sex'},
            {key:'f_age'},
            {key:'u_education'},
            {key:'u_workYear',prefix:'工作经验'},
            {key:'u_marriage'},
            {key:'u_liveAddress',prefix:'现居住'},
            {key:'createTime'},
          ]
          midDetailInfo=[
            {label:'教育经历',value:this.detailData.u_educationExperience},
            {label:'工作经历',value:this.detailData.u_workExperience},
            {label:'自我评价',value:this.detailData.selfComments},
            // {label:'联系名片',value:this.detailData.selfInfo},
          ]
          footDetailInfo=[
            {label:'姓名：',value:this.detailData.u_nickName},
            {label:'出生日期：',value:this.detailData.u_birthDayString},
            {label:'性别：',value:this.detailData.u_sex},
            {label:'身高：',value:this.detailData.u_height},
            {label:'普通话：',value:this.detailData.u_putonghua},
            {label:'外语能力：',value:this.detailData.u_waiyu},
            {label:'工作年限：',value:this.detailData.u_workYear+'年'},
            {label:'学历：',value:this.detailData.u_education},
            {label:'专业：',value:this.detailData.u_major},
            {label:'毕业院校：',value:this.detailData.u_school},
            {label:'所在地区：',value:this.detailData.u_liveAddress},
            {label:'婚否：',value:this.detailData.u_marriage},
            {label:'职位类别：',value:this.detailData.u_jobType},
            {label:'期望职位：',value:this.detailData.u_expectJob},
          ]
          break;
        case 'jiaoyu':
          topInfo = [
            {key:'hireStatus'},
            {key:'hireProperty'},
            {key:'hireClass'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'招生状态：',value:this.detailData.hireStatus},
            {label:'招生性质：',value:this.detailData.hireProperty},
            {label:'招生班次：',value:this.detailData.hireClass},
            {label:'毕业学历：',value:this.detailData.educationBackGround},
            {label:'地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'教育介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'教育机构名称：',value:this.detailData.name},
            {label:'招生人数：',value:this.detailData.hireCount},
            {label:'招生状态：',value:this.detailData.hireStatus},
            {label:'招生性质：',value:this.detailData.hireProperty},
            {label:'招生班次：',value:this.detailData.hireClass},
            {label:'毕业学历：',value:this.detailData.educationBackGround},
            {label:'颁发证书：',value:this.detailData.cert},
            {label:'招生对象：',value:this.detailData.hireTarget},
            {label:'地址：',value:this.detailData.address},
            {label:'浏览量：',value:this.detailData.viewTime},
          ]
          break;
        case 'peixun':
          topInfo = [
            {key:'trainingStatus'},
            {key:'traingingProperty'},
            {key:'trainingShifts'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'招培人数：',value:this.detailData.trainingCount},
            {label:'招培状态：',value:this.detailData.trainingStatus},
            {label:'招培对象：',value:this.detailData.trainingTarget},
            {label:'招培性质：',value:this.detailData.traingingProperty},
            {label:'地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'培训介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'培训机构名称：',value:this.detailData.name},
            {label:'招培人数：',value:this.detailData.trainingCount},
            {label:'招培状态：',value:this.detailData.trainingStatus},
            {label:'招培对象：',value:this.detailData.trainingTarget},
            {label:'招培性质：',value:this.detailData.traingingProperty},
            {label:'招培班次：',value:this.detailData.trainingShifts},
            {label:'招培专业：',value:this.detailData.trainingProfessional},
            {label:'颁发证书：',value:this.detailData.cert},
            {label:'培训地址：',value:this.detailData.address},
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'浏览次数：',value:this.detailData.viewTime},
          ]
          break;
        case 'rongzi':
          topInfo = [
            {key:'belongToDomain'},
            {key:'cash',suffix:'万元'},
            {key:'financeStatus'},
            {key:'status'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'融资额度：',value:this.detailData.cash+'万元'},
            {label:'融资状态：',value:this.detailData.financeStatus},
            {label:'项目状态：',value:this.detailData.status},
            {label:'融资地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'融资介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'融资机构名称：',value:this.detailData.name},
            {label:'融资额度：',value:this.detailData.cash+'万元'},
            {label:'融资状态：',value:this.detailData.financeStatus},
            {label:'项目状态：',value:this.detailData.status},
            {label:'融资计划书地址：',value:this.detailData.webSiteUrl},//没有
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'融资地点：',value:this.detailData.address},
            {label:'浏览次数：',value:this.detailData.viewTime},
          ]
          break;
        case 'touzi':
          topInfo = [
            {key:'belongToDomain'},
            {key:'cash',suffix:'万元'},
            {key:'investStatus'},
            {key:'status'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'投资额度：',value:this.detailData.cash+'万元'},
            {label:'投资状态：',value:this.detailData.investStatus},
            {label:'项目状态：',value:this.detailData.status},
            {label:'投资地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'投资介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'投资机构名称：',value:this.detailData.name},
            {label:'投资额度：',value:this.detailData.cash+'万元'},
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'投资状态：',value:this.detailData.investStatus},
            {label:'投资方式：',value:this.detailData.status},
            {label:'投资方案书：',value:this.detailData.webSiteUrl},//没有
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'投资地点：',value:this.detailData.address},
            {label:'浏览次数：',value:this.detailData.viewTime},
          ]
          break;
        case 'zhaoshang':
          topInfo = [
            {key:'belongToDomain'},
            {key:'attractInvestmentStatus'},
            {key:'requirement'},
            {key:'status'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'招商进展状态：',value:this.detailData.attractInvestmentStatus},//暂无
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'招商需求：',value:this.detailData.requirement},
            {label:'项目状态：',value:this.detailData.status},
            {label:'投资地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'投资介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'招商机构名称：',value:this.detailData.name},
            {label:'招商进展状态：',value:this.detailData.attractInvestmentStatus},
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'招商需求：',value:this.detailData.requirement},
            {label:'项目状态：',value:this.detailData.status},
            {label:'计划书地址：',value:this.detailData.webSiteUrl},//没有
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'招商地点：',value:this.detailData.address},
            {label:'浏览次数：',value:this.detailData.viewTime},
          ]
          break;
        case 'jiameng':
          topInfo = [
            {key:'belongToDomain'},
            {key:'joinInStatus'},
            {key:'requirement'},
            {key:'status'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'加盟进展状态：',value:this.detailData.joinInStatus},
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'招商需求：',value:this.detailData.requirement},
            {label:'项目状态：',value:this.detailData.status},
            {label:'投资地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'加盟介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'加盟机构名称：',value:this.detailData.name},
            {label:'加盟进展状态：',value:this.detailData.joinInStatus},
            {label:'所属行业：',value:this.detailData.belongToDomain},
            {label:'加盟需求：',value:this.detailData.requirement},
            {label:'项目状态：',value:this.detailData.status},
            {label:'计划书地址：',value:this.detailData.webSiteUrl},//没有
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'加盟地点：',value:this.detailData.address},
            {label:'浏览次数：',value:this.detailData.viewTime},
          ]
          break;
        case 'zufang':
          topInfo = [
            {key:'houseType'},
            {key:'areaSize',suffix:'平米'},
            {key:'progressStatus'},
            {key:'renovation'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'房屋面积：',value:this.detailData.areaSize+'平'},//暂无
            {label:'租房状态：',value:this.detailData.status},
            {label:'房屋类型：',value:this.detailData.requirement},
            {label:'是否合租：',value:this.detailData.isTogether},
            {label:'进展状态：',value:this.detailData.progressStatus},
            {label:'租房地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'租房介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'户型名称：',value:this.detailData.name},
            {label:'房屋面积：',value:this.detailData.areaSize+'平'},
            {label:'租房状态：',value:this.detailData.status},
            {label:'房屋类型：',value:this.detailData.houseType},
            {label:'是否合租：',value:this.detailData.isTogether},
            {label:'进展状态：',value:this.detailData.progressStatus},
            {label:'房屋配置：',value:this.detailData.houseConfig},
            {label:'租金：',value:this.detailData.rentCash+'元/月'},
            {label:'楼层：',value:this.detailData.layer},
            {label:'付款方式：',value:this.detailData.exchangeType},
            {label:'房龄：',value:this.detailData.houseAge},
            {label:'装修方式：',value:this.detailData.renovation},
            {label:'租房要求：',value:this.detailData.requirement},
            {label:'公交路线：',value:this.detailData.busNo},
            {label:'平面图地址：',value:this.detailData.planeUrl},
            {label:'租房地址：',value:this.detailData.address},
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'房屋详情：',value:this.detailData.showUrls},
          ]
          break;
        case 'shoufang':
          topInfo = [
            {key:'houseType'},
            {key:'areaSize',suffix:'平米'},
            {key:'progressStatus'},
            {key:'renovation'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'房屋面积：',value:this.detailData.areaSize+'平'},//暂无
            {label:'售房状态：',value:this.detailData.status},
            {label:'房屋类型：',value:this.detailData.houseType},
            {label:'房屋朝向：',value:this.detailData.direct},
            {label:'租房地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'售房介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'户型名称：',value:this.detailData.name},
            {label:'房屋面积：',value:this.detailData.areaSize+'平'},
            {label:'售房状态：',value:this.detailData.status},
            {label:'房屋类型：',value:this.detailData.houseType},
            {label:'房屋朝向：',value:this.detailData.direct},
            {label:'进展状态：',value:this.detailData.progressStatus},
            {label:'房屋配置：',value:this.detailData.houseConfig},
            {label:'价格：',value:this.detailData.saleCash+'万元'},
            {label:'楼层：',value:this.detailData.layer},
            {label:'付款方式：',value:this.detailData.exchangeType},
            {label:'房龄：',value:this.detailData.houseAge},
            {label:'装修方式：',value:this.detailData.renovation},
            {label:'房屋视图地址：',value:this.detailData.requirement},//
            {label:'平面图地址：',value:this.detailData.planeUrl},
            {label:'售房地址：',value:this.detailData.address},
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'房屋详情：',value:this.detailData.showUrls},
          ]
          break;
        case 'qiche':
          topInfo = [
            {key:'carType'},
            {key:'cash',suffix:'元'},
            {key:'driverDistance',suffix:'公里'},
            {key:'driverAge',suffix:'年'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime},
            {label:'汽车车型：',value:this.detailData.carType},
            {label:'售价：',value:this.detailData.cash},
            {label:'销售状态：',value:this.detailData.saleStatus},
            {label:'里程：',value:this.detailData.driverDistance},
            {label:'车龄：',value:this.detailData.driverAge},
          ]
          midDetailInfo=[
            {label:'汽车介绍',value:this.detailData.description},
            {label:'汽车配置',value:this.detailData.config},
            {label:'维修记录',value:this.detailData.maintain},
            {label:'保险情况',value:this.detailData.allowance},
          ]
          footDetailInfo=[
            {label:'汽车名称：',value:this.detailData.name},
            {label:'汽车车型：',value:this.detailData.carType},
            {label:'售价：',value:this.detailData.cash},
            {label:'销售状态：',value:this.detailData.saleStatus},
            {label:'里程：',value:this.detailData.driverDistance},
            {label:'车龄：',value:this.detailData.driverAge},
            {label:'进展状态：',value:this.detailData.progressStatus},
            {label:'付款方式：',value:this.detailData.exchangeType},
            {label:'生产地点：',value:this.detailData.address},
            {label:'网页地址：',value:this.detailData.webSiteUrl},
            {label:'详情图片：',value:this.detailData.showUrls},
          ]
          break;
        case 'jiaoyou':
          topInfo = [
            {key:'u_sex'},
            {key:'f_age',suffix:'岁'},
            {key:'u_height',suffix:'cm'},
            {key:'f_weight',suffix:'kg'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'性别：',value:this.detailData.u_sex},
            {label:'年龄：',value:this.detailData.f_age},
            {label:'身高：',value:this.detailData.u_height},
            {label:'体重：',value:this.detailData.f_weight},
            {label:'学历：',value:this.detailData.u_education},
          ]
          midDetailInfo=[
            {label:'自我介绍',value:this.detailData.f_description},
            {label:'交友要求',value:this.detailData.f_requirement},
            {label:'秘密档案',value:this.detailData.f_secDoc},
          ]
          footDetailInfo=[
            {label:'姓名：',value:this.detailData.u_nickName},
            {label:'性别：',value:this.detailData.u_sex},
            {label:'年龄：',value:this.detailData.f_age},
            {label:'身高：',value:this.detailData.u_height},
            {label:'体重：',value:this.detailData.f_weight},
            {label:'学历：',value:this.detailData.u_education},
            {label:'婚姻状况：',value:this.detailData.u_marriage},
            {label:'性格：',value:this.detailData.f_disposition},
            {label:'交友方式：',value:this.detailData.f_friends},
            {label:'工作地点：',value:this.detailData.f_wordAddress},
          ]
          break;
        case 'gouwu':
          topInfo = [
            {key:'catalog'},
            {key:'price',suffix:'元'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'单价：',value:this.detailData.price+'元'},
            {label:'物品类别：',value:this.detailData.catalog},
            {label:'送货方式：',value:this.detailData.deliveryType},
            {label:'实体店地址：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'购物介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'商品名称：',value:this.detailData.name},
            {label:'单价：',value:this.detailData.price+'元'},
            {label:'物品类别：',value:this.detailData.catalog},
            {label:'送货方式：',value:this.detailData.deliveryType},
            {label:'实体店地址：',value:this.detailData.address},
          ]
          break;
        case 'meishi':
          topInfo = [
            {key:'foodType'},
            {key:'costStandard',suffix:'元/人'},
            {key:'orderStatus'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'美食类别：',value:this.detailData.foodType},
            {label:'消费标准：',value:this.detailData.costStandard +'元/人'},
            {label:'送货方式：',value:this.detailData.deliveryType},
            {label:'容纳人数：',value:this.detailData.persons},
            {label:'预定状态：',value:this.detailData.orderStatus},
            {label:'美食地点：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'美食介绍',value:this.detailData.description},
            {label:'美食特色',value:this.detailData.foodUnique},
          ]
          footDetailInfo=[
            {label:'美食名称：',value:this.detailData.name},
            {label:'美食类别：',value:this.detailData.foodType},
            {label:'消费标准：',value:this.detailData.costStandard +'元/人'},
            {label:'送货方式：',value:this.detailData.deliveryType},
            {label:'容纳人数：',value:this.detailData.persons},
            {label:'预定状态：',value:this.detailData.orderStatus},
            {label:'美食地点：',value:this.detailData.address},
          ]
          break;
        case 'lvyou':
          topInfo = [
            {key:'tourUnique'},
            {key:'costStandard',suffix:'元/人'},
            {key:'orderStatus'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'消费标准：',value:this.detailData.costStandard +'元/人'},
            {label:'特色：',value:this.detailData.tourUnique},
            {label:'容纳人数：',value:this.detailData.persons},
            {label:'预定状态：',value:this.detailData.orderStatus},
            {label:'旅游地点：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'旅游介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'旅游名称：',value:this.detailData.name},
            {label:'特色：',value:this.detailData.tourUnique},
            {label:'消费标准：',value:this.detailData.costStandard+'元/人'},
            {label:'容纳人数：',value:this.detailData.persons},
            {label:'预定状态：',value:this.detailData.orderStatus},
            {label:'旅游地点：',value:this.detailData.address},
            {label:'行程天数：',value:this.detailData.tourDays+'天'},
          ]
          break;
        case 'jiankang':
          topInfo = [
            {key:'orderStatus'},
            {key:'okPersons'},
            {key:'medicalType'},
            {key:'healUnique'},
          ]
          headDetailInfo=[
            {label:'发布日期：',value:this.detailData.createTime},
            {label:'浏览量：',value:this.detailData.viewTime+'次'},
            {label:'预定状态：',value:this.detailData.orderStatus},
            {label:'适宜人群：',value:this.detailData.okPersons},
            {label:'医疗方式：',value:this.detailData.medicalType},
            {label:'医疗机构地点：',value:this.detailData.address},
          ]
          midDetailInfo=[
            {label:'健康介绍',value:this.detailData.description},
          ]
          footDetailInfo=[
            {label:'医疗机构名称：',value:this.detailData.name},
            {label:'适宜人群：',value:this.detailData.okPersons},
            {label:'特色：',value:this.detailData.healUnique},
            {label:'医疗方式：',value:this.detailData.medicalType},
            {label:'医疗科别：',value:this.detailData.medicalCatalog},
            {label:'医疗状态：',value:this.detailData.status},
            {label:'医疗机构地点：',value:this.detailData.address},
            {label:'专家释疑：',value:this.detailData.professional},
          ]
          break;
      }
      let showDetailInfo = {
        typeName,
        headImg,
        companyHeadImg,
        name,
        topInfo,
        headDetailInfo,
        midDetailInfo,
        footDetailInfo,
      }
      console.log(showDetailInfo)
      return showDetailInfo
    },
    
    getCompanyInfo() {
      if (!['qiuzhi', 'jiaoyou'].includes(this.navAc)) {
        let o_name = this.$route.query.oname
        return this.$api._user_companyInfo({o_name}).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            if (_R.length) {
              console.log(`%c公司:`, 'color: #00f;', _R[0])
              this.companyData = _R[0]
            // } else { this.$message.info('未找到相关企业信息') }
            }
          } else { this._status(res.data) }
        })
      }
    },
    
    getData() {
      let rD = { id: this.id }
      return this.$api.util_search(this.navAc, rD).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c详情:`, 'color: #00f;', _R[0])
          this.detailData = _R[0]
          this.isShowPictures = this.detailData.hasOwnProperty('showUrls')
          if (this.detailData.showUrls) {
            this.detailData.showUrls.forEach( x => {
              this.showPicturesArr.push(x)
            })
          }
        } else { this._status(res.data) }
      })
    },
    
  },
  //进入路由之前，获取详情数据
  beforeRouteEnter (to, from, next) {
    if (to.path !== from.path) {
      document.documentElement.scrollTop = 0
    }
    next(async vm => {
      let { id, type } = to.query
      if (type && id) {
        vm.navAc = type
        vm.id = id
        await vm.getData()
        await vm.getCompanyInfo()
        vm.showDetailInfo = vm.dataHandler()
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.companyData = {}
    next()
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-menu--horizontal{
  border:1px solid #e6e6e6;
  border-top: 0px;
}
.el-menu--horizontal>.el-menu-item{
  font-size: 18px;
}


.Imgbg{
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(../images/log-reg-bg.jpg) no-repeat center center;
  margin-bottom: 30px;
}
.Imgbg .headbox {
  text-align: center;
  margin: 0 auto;
}
.Imgbg .headbox .kuang{
  width: 120px;
  height: 120px;
  margin: auto;
  padding: 15px;
  background-color: #ffffff;
}
.Imgbg .headbox img{
  width: 120px;
  height: 120px;
}
.Imgbg .headbox .name{
  font-size: 30px;
  text-align: center;
  color: #ffffff;
  width: 100%;
  height: 40px;
  padding: 20px 0;
}
.Imgbg .headbox .info{
  font-size: 14px;
  color: #ffffff;
  height: 28px;
  line-height: 28px;
  width: 100%;
  text-align: center;
}
.Imgbg .headbox .info span{
  padding: 0 5px;
}
/* 背景图部分借宿 */


.showDetailbox{
  margin-top: 30px;
  margin-bottom: 50px;
  justify-content: space-between;
  align-items:stretch;
  color: #666;
}
.showDetailbox .left{
  width: 850px;
}
.showDetailbox .left .typeName{
  position: relative;
  height: 50px;
  line-height: 50px;
  padding: 0 15px;
  border: 1px solid #eeeeee;
}
.showDetailbox .left .typeName .shu{
  display: inline-block;
  border: 1.5px solid red;
  height: 18px;
  position: absolute;
  top: 15px;
}
.showDetailbox .left .typeName b{
  margin-left: 10px;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #333333;
}
.showDetailbox .left .headInfo{
  margin-top: -1px;
  justify-content: space-between;
  align-items:stretch;
  border: 1px solid #eeeeee;
  padding: 20px;
}
.showDetailbox .left .headInfo img{
  width: 216px;
  height: 154px;
}
.showDetailbox .left .headInfo .info{
  padding-left: 20px;
}
.showDetailbox .left .headInfo .info span{
  display: inline-block;
  width: 50%;
  line-height: 28px;
  font-size: 14px;
  color: #666666;
}
.showDetailbox .left .headInfo .info .name{
  width: 100%;
  font-size: 22px;
  margin-bottom: 10px;
}
/* 有展示视频的样式 */
.showDetailbox .left .infobox .videobox{
  border: 1px solid #eeeeee;
  border-top: 0px;
}
.showDetailbox .left .infobox .videobox .textdiv{
  padding: 15px;
}
.showDetailbox .left .infobox .videobox .videodiv video{
  display: block;
  margin: 0px auto;
  width: 500px;
}




.showDetailbox .left .descriptionInfo .descriptionName{
  position: relative;
  font-size: 16px;
  color: #666666;
  padding-left: 15px;
  height: 50px;
  border: 1px solid #eeeeee;
  margin-top: -1px;
  line-height: 50px;
  background-color: #f8f8f8;
}
.showDetailbox .left .descriptionInfo .descriptionName .shu{
  display: inline-block;
  border: 1.5px solid red;
  height: 18px;
  position: absolute;
  top: 15px;
}
.showDetailbox .left .descriptionInfo .descriptionName b{
  margin-left: 15px;
}
.showDetailbox .left .descriptionInfo .descriptionCont{
  border: 1px solid #eeeeee;
  margin-top: -1px;
  line-height: 26px;
  padding: 15px;
}

.showDetailbox .left .detailInfo{
  margin-top: 20px;
}
.showDetailbox .left .detailInfo .title{
  position: relative;
  height: 50px;
  line-height: 50px;
  padding: 0 15px;
  border: 1px solid #eeeeee;
}
.showDetailbox .left .detailInfo .title .shu{
  display: inline-block;
  border: 1.5px solid red;
  height: 18px;
  position: absolute;
  top: 15px;
}
.showDetailbox .left .detailInfo .title b{
  margin-left: 10px;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #333333;
}
.showDetailbox .left .detailInfo .cont{
  position: relative;
  padding: 15px;
  margin-top: -1px;
  border: 1px solid #eeeeee;
}
.showDetailbox .left .detailInfo .cont span.list {
  padding: 5px 0px;
  font-size: 14px;
  line-height: 28px;
  width: 50%;
  display: inline-block;
}
.showDetailbox .left .detailInfo .cont .isShow:last-of-type{
  display: block;
  width: 100%;
}
.showDetailbox .left .detailInfo .cont span .pictures .imgbox{
  display: inline-block;
  width: 16%;
  height: 150px;
  padding: 5px;
  margin: 0px 5px;
}
.showDetailbox .right{
  color: #666;
  width: 320px;
}
.showDetailbox .right .btnbox{
  flex-wrap: wrap;
  justify-content: space-between;
}
.showDetailbox .right .btnbox .el-button{
  display: block;
  margin: 0px 0px 10px 0px;
  width: 47%;
  height: 44px;
  font-size: 18px;
}
.showDetailbox .right .btnbox .el-button:last-child{
  width: 100%;
}
/* 邀请面试的弹框 */
.inviteInterDialog{
  height: 260px;
  margin-top: 200px!important;
  overflow-y: auto;
}
</style>